module.exports = __webpack_public_path__ + "img/fondo_login.89e9ffc4.jpg";